var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('section',{class:_vm.shit$("fixed; top:0px; left:50%; z:2001;")},[_c('message-item'),_c('div',{class:_vm.shit$("")})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }